<template>
	<div>
		<a-layout class="layout-default layout-default-profile" id="layout-default" :class="[route.meta.layoutClass]">
			<DefaultHeader></DefaultHeader>
			<a-layout-content>
				<!-- <a-row class="profile-layout-row" :class="{ 'is-slide-collapsed': slideCollapsed }">
					<a-col
						:xs="0"
						:lg="slideCollapsed ? 2 : 6"
						class="profile-layout-slide"
					>
						<Slide @collapsed-change="onSlideCollapsedChange" />
					</a-col>

					<a-col
						:xs="24"
						:lg="slideCollapsed ? 22 : 18"
						class="profile-layout-main"
					>
						<router-view />
					</a-col>
				</a-row> -->
				<ManageNews></ManageNews>
				
			</a-layout-content>
			<DefaultFooter></DefaultFooter>
			<Social></Social>
		</a-layout>
	</div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import DefaultHeader from "@/components/Headers/DefaultHeader.vue";
import DefaultFooter from "@/components/Footers/DefaultFooter.vue";
import Slide from '@/layouts/default/profile/SlideProfile.vue'
import Social from '@/components/social/Social.vue'
import ManageNews from '@/layouts/default/profile/ManageNews.vue'
import ManageBuilding from '@/layouts/default/profile/ManageBuilding.vue'
import { useRoute } from "vue-router";
import { AppleOutlined, AndroidOutlined } from '@ant-design/icons-vue';

const route = useRoute();
const slideCollapsed = ref(false)

const onSlideCollapsedChange = (value: boolean) => {
	slideCollapsed.value = value
}
const activeKey = ref('1');
// onMounted(()=>{
// 	let ref = route.query.ref || '';
// 	if(ref != '') {
// 		commons.setLocalStorage(USER_REF, ref)
// 		login(ref)
// 	}
	
// })
// const login = async (ref: any) =>  {
// 		const dataRequest = {
//         userName: ref,
//         password: ref,
//       };
//       await apiPost(USER_V1_LOGIN, dataRequest).then((res) => {
//         let response: any = res;
//         if (response.data.statusCode == 200) {
//           let dataLogin = response.data.data;
//           checkUser(dataLogin);
//         }
//       });
// }

// const checkUser = (dataLogin: any) => {
//   commons.setUserInform(dataLogin);
//   commons.setCokiesUser(dataLogin);
// };
</script>

<style scoped>
.profile-layout-row {
  min-height: calc(100vh - 120px);
}

.profile-layout-slide {
  background: var(--tp-bg, #ffffff);
}

.profile-layout-main {
  padding: 16px 20px 32px;
  background: var(--tp-bg, #ffffff);
  color: var(--default-color);
  font-family: var(--default-font);
}

.profile-layout-main:has(.pn-page) {
  padding: 0;
}

@media (max-width: 991px) {
  .profile-layout-main {
    padding: 12px 12px 24px;
  }

  .profile-layout-main:has(.pn-page) {
    padding: 0;
  }
}
/* .tab-profile .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list{
	margin-left: 25px !important;
} */
</style>
<!-- <script>

	import DefaultHeader from '../components/Headers/DefaultHeader' ;
	import DefaultFooter from '../components/Footers/DefaultFooter' ;

	export default ({
		components: {
			DefaultHeader,
			DefaultFooter,
		},
		data() {
			return {
			}
		},
		computed: {
			// Sets layout's element's class based on route's meta data.
			layoutClass() {
				return this.$route.meta.layoutClass ;
			}
		},
	})

</script> -->